import { PropsWithChildren } from 'react';

export type HeadingProps = {
  level?: string | number;
  className?: string;
  id?: string;
};

const Heading = ({ children, id, level = 1, className }: PropsWithChildren<HeadingProps>) => {
  if (!children) return null;
  const HeadingTag: any = `h${level}`;
  return (
    <HeadingTag id={id} className={className}>
      {children}
    </HeadingTag>
  );
};

export default Heading;
